import Fragment from './Fragment';

export default class TopLayout extends Fragment {
    constructor(helper) {
        super(helper);
        this.$fragment.append('<!DOCTYPE html>');
        this.$html = $.create('html').appendTo(this.$fragment);
        this.$head = $.create('head').appendTo(this.$html);
        this.$body = $.create('body').appendTo(this.$html);
        this.$content = $.create('div');
    }

    init() {

    }

    _initElements() {
    }
}
